module.exports = __webpack_public_path__ + "static/media/01.c4324665.jpg";